export const getDeadTime = (duration = '') => {
    //let deadline = new Date("2022-07-08T00:00:00") ;
    let deadline = new Date(duration || '0000-00-00T00:00:00');
    // This is where you need to adjust if 
    // you entend to add more time 
    return deadline;
}